"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3997],{

/***/ 3997:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "BlockTips": function() { return /* binding */ BlockTips; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./src/ui/index.ts + 16 modules
var ui = __webpack_require__(4522);
// EXTERNAL MODULE: ./src/ui/cursive-basic.tsx
var cursive_basic = __webpack_require__(4693);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/embla-carousel-react/embla-carousel-react.umd.js
var embla_carousel_react_umd = __webpack_require__(9213);
var embla_carousel_react_umd_default = /*#__PURE__*/__webpack_require__.n(embla_carousel_react_umd);
// EXTERNAL MODULE: ./node_modules/next/future/image.js
var future_image = __webpack_require__(1608);
var image_default = /*#__PURE__*/__webpack_require__.n(future_image);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./src/components/common/icons/index.ts + 9 modules
var icons = __webpack_require__(9257);
;// CONCATENATED MODULE: ./src/components/nutrition/article-recommended.tsx

/* eslint-disable camelcase */ 


var ArticleRecommendedCarousel = function(param) {
    var data = param.data;
    var ref, ref1;
    console.log("data", data);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)((link_default()), {
        className: "relative mr-8 grid h-full w-[300px] grid-cols-1 rounded-lg shadow-ecPrimary-4 lg:w-[440px]",
        href: "/nutrition/".concat(data === null || data === void 0 ? void 0 : data.slug),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                src: (data === null || data === void 0 ? void 0 : data.featuredMedia) || "/assets/images/product-image-placeholder.svg",
                className: "h-[220px] rounded-t-lg object-cover lg:h-[363px] mr-[5%]",
                fill: true,
                alt: data === null || data === void 0 ? void 0 : (ref = data.title) === null || ref === void 0 ? void 0 : ref.rendered,
                priority: true,
                width: 615,
                height: 615
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex h-full w-full items-center justify-between rounded-b-lg bg-colorFourteen p-5 font-bold text-colorFifteen",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "w-[80%] flex-wrap sm:text-base lg:text-lg",
                        children: data === null || data === void 0 ? void 0 : (ref1 = data.title) === null || ref1 === void 0 ? void 0 : ref1.rendered
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* ArrowRight */.ol, {
                        fill: "rgb(203, 153, 114)"
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/common/carousel/slider-tips.tsx





var EmblaCarouselTips = function(props) {
    var sliderData = props.sliderData;
    var data = sliderData.concat(sliderData, sliderData);
    var randomSlideIndexOrder = (0,react.useMemo)(function() {
        var randomIndex = Math.floor(Math.random() * sliderData.length);
        return randomIndex;
    }, [
        sliderData
    ]);
    var ref = (0,_sliced_to_array/* default */.Z)(embla_carousel_react_umd_default()({
        loop: false,
        dragFree: false
    }), 2), emblaRef = ref[0], embla = ref[1];
    var rafId = (0,react.useRef)(0);
    var animate = (0,react.useCallback)(function() {
        if (!embla || !rafId.current) return;
        var engine = embla.internalEngine();
        engine.location.add(-1);
        engine.target.set(engine.location);
        if (engine.location.get() <= engine.scrollSnaps[7]) {
            console.log("qweqe");
            engine.scrollLooper.loop(1);
            engine.translate.to(engine.location);
            rafId.current = requestAnimationFrame(reanimate);
        } else {
            engine.scrollLooper.loop(-1);
            engine.translate.to(engine.location);
            rafId.current = requestAnimationFrame(animate);
        }
    }, [
        embla
    ]);
    var reanimate = (0,react.useCallback)(function() {
        if (!embla || !rafId.current) return;
        var engine = embla.internalEngine();
        engine.location.add(1);
        engine.target.set(engine.location);
        if (500 < engine.scrollSnaps[0] && engine.scrollSnaps[0] < 1000) {
            if (engine.location.get() >= 160) {
                engine.scrollLooper.loop(-1);
                engine.translate.to(engine.location);
                rafId.current = requestAnimationFrame(animate);
            } else {
                engine.scrollLooper.loop(1);
                engine.translate.to(engine.location);
                rafId.current = requestAnimationFrame(reanimate);
            }
        } else {
            if (engine.location.get() >= 30) {
                engine.scrollLooper.loop(-1);
                engine.translate.to(engine.location);
                rafId.current = requestAnimationFrame(animate);
            } else {
                engine.scrollLooper.loop(1);
                engine.translate.to(engine.location);
                rafId.current = requestAnimationFrame(reanimate);
            }
        }
    }, [
        embla
    ]);
    var startAutoScroll = (0,react.useCallback)(function() {
        rafId.current = requestAnimationFrame(animate);
    }, [
        animate
    ]);
    var startAgain = (0,react.useCallback)(function() {
        rafId.current = requestAnimationFrame(reanimate);
    }, [
        reanimate
    ]);
    var stopAutoScroll = (0,react.useCallback)(function() {
        rafId.current = cancelAnimationFrame(rafId.current) || 0;
    }, []);
    // const animate = useCallback(() => {
    //   if (!embla || !rafId.current) return;
    //   const engine = embla.internalEngine();
    //   engine.location.add(-0.5);
    //   engine.target.set(engine.location);
    //   engine.scrollLooper.loop(-1);
    //   if(engine.location.get() <= engine.scrollSnaps[engine.scrollSnaps.length - 1])
    //   {
    //     console.log('../////')
    //     engine.location.set(160)
    //     engine.translate.to(engine.location);
    //     rafId.current = requestAnimationFrame(animate);
    //   }else{
    //     engine.translate.to(engine.location);
    //     rafId.current = requestAnimationFrame(animate);
    //   }
    // }, [embla]);
    // const startAutoScroll = useCallback(() => {
    //   rafId.current = requestAnimationFrame(animate);
    // }, [animate]);
    // const stopAutoScroll = useCallback(() => {
    //   rafId.current = cancelAnimationFrame(rafId.current) || 0;
    // }, []);
    var mouseOver = (0,react.useCallback)(function() {
        stopAutoScroll();
    }, [
        embla
    ]);
    var mouseLeave = (0,react.useCallback)(function() {
        startAutoScroll();
    }, [
        embla
    ]);
    (0,react.useEffect)(function() {
        if (!embla) return;
        var engine = embla.internalEngine();
        if (engine.location.get() > 35 && engine.location.get() < 60) {
            engine.location.set(45);
        } else {
            engine.location.set(160);
        }
        embla.on("pointerDown", stopAutoScroll);
        embla.on("settle", startAutoScroll);
        startAutoScroll();
        return function() {
            return stopAutoScroll();
        };
    }, [
        embla,
        startAutoScroll,
        stopAutoScroll,
        startAgain
    ]);
    (0,react.useEffect)(function() {
        var innerWidth = window.innerWidth, innerHeight = window.innerHeight;
        window.onscroll = function() {
            if (innerWidth < 400) {
                console.log("?", document.documentElement.scrollTop);
                if (document.documentElement.scrollTop <= 700 || document.documentElement.scrollTop >= 1300) {
                    stopAutoScroll();
                }
                if (document.documentElement.scrollTop <= 3600 || document.documentElement.scrollTop >= 4200) {
                    stopAutoScroll();
                }
            } else {
                // console.log('????', )
                if (document.documentElement.scrollTop <= 2800 || document.documentElement.scrollTop >= 3600) {
                    stopAutoScroll();
                }
                if (document.documentElement.scrollTop <= 500 || document.documentElement.scrollTop >= 1300) {
                    stopAutoScroll();
                }
            }
        };
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        className: "h-full max-w-full",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "embla relative",
            ref: emblaRef,
            onMouseOver: mouseOver,
            onMouseLeave: mouseLeave,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "grid grid-flow-col",
                children: data.map(function(slide) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ArticleRecommendedCarousel, {
                        data: slide
                    }, slide.id);
                })
            })
        })
    });
};

;// CONCATENATED MODULE: ./src/components/common/homepage/block_tips.tsx




var BlockTips = function(param) {
    var articles = param.articles;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ui/* GradientWrap */.Mx, {
        className: "bg-split-bg py-20",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ui/* Wrapper */.im, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "grid grid-cols-1 text-left sm:grid-cols-[2fr_1fr]",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ui/* Title */.Dx, {
                            className: "col-span-full text-colorFourteen",
                            children: "Tips for Pup Parents"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(cursive_basic/* CursiveBasic */.x, {
                                    children: "Resources from our team of canine experts "
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ui/* Text */.xv, {
                                    className: "text-colorFourteen",
                                    children: "Ready to be the best pet parent ever? Get expert advice on all things a healthy dog would need, from a balanced diet to caring for your best furry friend."
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "py-10",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ui/* ButtonWithArrow */.Ub, {
                                center: true,
                                href: "/nutrition",
                                className: "w-[310px] lg:w-[240px]",
                                children: "Nutrition Advice"
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "h-full w-full pt-8",
                children: articles && articles.length > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(EmblaCarouselTips, {
                    sliderData: articles
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "text-center",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ui/* Title */.Dx, {
                        className: "pt-6 text-colorFourteen",
                        children: "No articles found"
                    })
                })
            })
        ]
    });
};


/***/ }),

/***/ 4693:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "x": function() { return /* binding */ CursiveBasic; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);

var CursiveBasic = function(param) {
    var children = param.children, _className = param.className, className = _className === void 0 ? "" : _className;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "m-auto font-madelyn text-sliderTitle text-colorSixteen lg:text-blockHeader ".concat(className),
        children: children
    });
};


/***/ })

}]);